import React from 'react';
import MessageIcon from 'assets/dark-message-icon.svg?react';
import CloseIcon from 'assets/close-icon-light.svg?react';
import applicationMessage from 'screens/Applications&WorkOrders/StepsLayout/Components/Message';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';

const InfoMessage = ({
  content = '',
  onUndo,
  onClose
}: {
  content: string | React.ReactNode;
  onUndo?: () => void;
  onClose: () => void;
}) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <MessageIcon aria-hidden="true" />
        <p className="text-base">{content}</p>
      </div>
      <div className="flex items-center gap-2">
        {onUndo && (
          <Button type={ButtonType.primary} size="small" onClick={onUndo} ghost>
            Undo
          </Button>
        )}
        <button aria-label="Close" type="button" onClick={onClose}>
          <CloseIcon aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export const showMessage = ({
  content,
  onUndo,
  onClose,
  config = { key: '', icon: <></> }
}: {
  content: string | React.ReactNode;
  onUndo?: () => void | null;
  onClose: () => void;
  config?: {
    key: string;
    icon?: React.ReactNode;
  };
}) => {
  return applicationMessage(
    'success',
    {
      content: (
        <InfoMessage content={content} onUndo={onUndo} onClose={onClose} />
      ),
      duration: 10,
      icon: config.icon,
      key: config.key
    },
    'dark'
  );
};

export default InfoMessage;
